let bankDetailsCols = [
    {
        key: 'name',
        display: 'Bank / Building Society Name'
    },
    {
        key: 'accountName',
        display: 'Account Name'
    },
    {
        key: 'accountNumber',
        display: 'Account Number'
    },
    {
        key: 'accountSortcode',
        display: 'Account Sortcode'
    },
    {
        key: 'dateCreated',
        display: 'Created Date'
    }
]

export { bankDetailsCols }